// plain js doc ready  function
document.addEventListener('DOMContentLoaded', function() {
    initFAQDataLayer();
});

const initFAQDataLayer = () => {
    // faqs are in .s-list-expandable .c-list-expandable .c-list-expandable__item
    const faqs = document.querySelectorAll('.s-list-expandable .c-list-expandable .c-list-expandable__item');

    window.dataLayer = window.dataLayer || [];

    faqs.forEach((faq) => {
        faq.addEventListener('click', function() {
            const question = faq.querySelector('.c-list-expandable__title').innerText;

            window.dataLayer.push({
                event: 'faq',
                question: question,
            });
        });
    }); 
}


// WEBPACK FOOTER //
// ./scripts/routes/other/datalayers.js